export const shellTranslations = {
  en: {
    skipToMainContent: "Skip to main content",
    publicNavigation: "Public navigation",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    search: "Search",
    trustPolicies: "Trust & Policies",
    upgradeToPremium: "Upgrade to Premium",
    collapseSidebar: "Collapse sidebar",
  },
  he: {
    skipToMainContent: "דלגו לתוכן הראשי",
    publicNavigation: "ניווט ציבורי",
    openMenu: "פתח תפריט",
    closeMenu: "סגור תפריט",
    search: "חיפוש",
    trustPolicies: "אמון ומדיניות",
    upgradeToPremium: "שדרוג לפרימיום",
    collapseSidebar: "כווץ סרגל צד",
  },
  es: {
    skipToMainContent: "Saltar al contenido principal",
    publicNavigation: "Navegación pública",
    openMenu: "Abrir menú",
    closeMenu: "Cerrar menú",
    search: "Buscar",
    trustPolicies: "Confianza y políticas",
    upgradeToPremium: "Actualizar a Premium",
    collapseSidebar: "Contraer barra lateral",
  },
  it: {
    skipToMainContent: "Vai al contenuto principale",
    publicNavigation: "Navigazione pubblica",
    openMenu: "Apri menu",
    closeMenu: "Chiudi menu",
    search: "Cerca",
    trustPolicies: "Fiducia e politiche",
    upgradeToPremium: "Passa a Premium",
    collapseSidebar: "Comprimi barra laterale",
  },
  fr: {
    skipToMainContent: "Aller au contenu principal",
    publicNavigation: "Navigation publique",
    openMenu: "Ouvrir le menu",
    closeMenu: "Fermer le menu",
    search: "Rechercher",
    trustPolicies: "Confiance et politiques",
    upgradeToPremium: "Passer à Premium",
    collapseSidebar: "Réduire la barre latérale",
  },
  de: {
    skipToMainContent: "Zum Hauptinhalt springen",
    publicNavigation: "Öffentliche Navigation",
    openMenu: "Menü öffnen",
    closeMenu: "Menü schließen",
    search: "Suchen",
    trustPolicies: "Vertrauen & Richtlinien",
    upgradeToPremium: "Auf Premium upgraden",
    collapseSidebar: "Seitenleiste einklappen",
  },
  pt: {
    skipToMainContent: "Ir para o conteúdo principal",
    publicNavigation: "Navegação pública",
    openMenu: "Abrir menu",
    closeMenu: "Fechar menu",
    search: "Pesquisar",
    trustPolicies: "Confiança e políticas",
    upgradeToPremium: "Atualizar para Premium",
    collapseSidebar: "Recolher barra lateral",
  },
  ar: {
    skipToMainContent: "انتقل إلى المحتوى الرئيسي",
    publicNavigation: "التنقل العام",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    search: "بحث",
    trustPolicies: "الثقة والسياسات",
    upgradeToPremium: "الترقية إلى بريميوم",
    collapseSidebar: "طي الشريط الجانبي",
  },
  el: {
    skipToMainContent: "Μετάβαση στο κύριο περιεχόμενο",
    publicNavigation: "Δημόσια πλοήγηση",
    openMenu: "Άνοιγμα μενού",
    closeMenu: "Κλείσιμο μενού",
    search: "Αναζήτηση",
    trustPolicies: "Εμπιστοσύνη και πολιτικές",
    upgradeToPremium: "Αναβάθμιση σε Premium",
    collapseSidebar: "Σύμπτυξη πλευρικής μπάρας",
  },
  ru: {
    skipToMainContent: "Перейти к основному содержанию",
    publicNavigation: "Публичная навигация",
    openMenu: "Открыть меню",
    closeMenu: "Закрыть меню",
    search: "Поиск",
    trustPolicies: "Доверие и политики",
    upgradeToPremium: "Перейти на Premium",
    collapseSidebar: "Свернуть боковую панель",
  },
  tr: {
    skipToMainContent: "Ana içeriğe geç",
    publicNavigation: "Genel gezinme",
    openMenu: "Menüyü aç",
    closeMenu: "Menüyü kapat",
    search: "Ara",
    trustPolicies: "Güven ve politikalar",
    upgradeToPremium: "Premium'a yükselt",
    collapseSidebar: "Yan çubuğu daralt",
  },
  zh: {
    skipToMainContent: "跳到主要内容",
    publicNavigation: "公共导航",
    openMenu: "打开菜单",
    closeMenu: "关闭菜单",
    search: "搜索",
    trustPolicies: "信任与政策",
    upgradeToPremium: "升级到高级版",
    collapseSidebar: "折叠侧边栏",
  },
};

export function getShellCopy(lang) {
  return shellTranslations[lang] || {};
}